export const STORAGE_TERMS_PROVIDER_KEY = '@selected_terms_provider_settings';

export const TERMS_PROVIDER_STATUS = {
  INITIAL: 'INITIAL',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  NOT_ELEGIBLE: 'NOT_ELEGIBLE',
};